import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
export const ConnectionStatus = {
  UNINITIALIZED: 'UNINITIALIZED',
  CONNECTING: 'CONNECTING',
  CONNECTED: 'CONNECTED',
  FAILED_TO_CONNECT: 'FAILED_TO_CONNECT',
  DISCONNECTING: 'DISCONNECTING',
  DISCONNECTED: 'DISCONNECTED'
};
var _instance = /*#__PURE__*/_classPrivateFieldLooseKey("instance");
var _status = /*#__PURE__*/_classPrivateFieldLooseKey("status");
export class ConnectionStateManager {
  constructor() {
    Object.defineProperty(this, _status, {
      writable: true,
      value: ConnectionStatus.UNINITIALIZED
    });
    this.getStatus = () => _classPrivateFieldLooseBase(this, _status)[_status];
    this.setStatus = status => {
      _classPrivateFieldLooseBase(this, _status)[_status] = status;
    };
    this.canDisconnect = () => [ConnectionStatus.CONNECTED, ConnectionStatus.CONNECTING].includes(_classPrivateFieldLooseBase(this, _status)[_status]);
    this.canConnect = () => [ConnectionStatus.UNINITIALIZED, ConnectionStatus.DISCONNECTED, ConnectionStatus.FAILED_TO_CONNECT].includes(_classPrivateFieldLooseBase(this, _status)[_status]);
  }
}
Object.defineProperty(ConnectionStateManager, _instance, {
  writable: true,
  value: void 0
});
ConnectionStateManager.getInstance = () => {
  if (!_classPrivateFieldLooseBase(ConnectionStateManager, _instance)[_instance]) {
    _classPrivateFieldLooseBase(ConnectionStateManager, _instance)[_instance] = new ConnectionStateManager();
  }
  return _classPrivateFieldLooseBase(ConnectionStateManager, _instance)[_instance];
};